import { render, staticRenderFns } from "./IndagineEpidemiologicaEpatiteEEditComponent.vue?vue&type=template&id=4f15f930"
import script from "./IndagineEpidemiologicaEpatiteEEditComponent.vue?vue&type=script&lang=js"
export * from "./IndagineEpidemiologicaEpatiteEEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports